import type { ConfirmRequestSource } from '@ctcells/contract'

/**
 * **이 화면이 떠 있는 표면(surface)** — 확약 창구(`confirm_source`)를 정하는 유일한 자리.
 *
 * 🔴 **화면은 「내가 어느 표면인가」를 추론하지 않는다.** 표면은 셸(레이아웃)이 선언하고
 *    (`@ctcells/ui` `SurfaceProvider`), 확약 훅은 그 값을 받아 싣기만 한다.
 *    주소·UA·창 크기로 짐작하지 마라 — 서버도 이 값을 «자기 선언»으로 받는다(참인지 못 가린다).
 *
 *   console  통합 콘솔(사용자 PC 데스크톱 앱)       → `client_app`
 *   tablet   `/tablet` kiosk(모듈별 태블릿)         → `tablet`
 *   module   모듈 패드 3종(모듈 로컬 UI)            → **L2 확약 창구 없음**(`null`)
 *
 * ⚠ `module` 이 `module_local` 이 아니라 `null` 인 이유(2026-09-26 실서버 `openapi.json` 실측):
 *   `POST /loads/{id}/confirm` 의 `confirm_source` 열거가 `tablet | client_app | dev_auto` 셋뿐이고,
 *   서버 설명이 「`module_local`·`robot_pick` 은 이 경로의 값이 아니다」라고 적었다. 모듈 패드는
 *   모듈 로컬 경로로 확약한다 — 이 표에 `module_local` 을 넣으면 L2 로 422 가 나간다.
 * ⚠ `dev_auto`(개발 모드 프로그램 확약)는 **화면이 보내지 않는다.** 여기 두지 않는다.
 */
export type AppSurface = 'console' | 'tablet' | 'module'

export const CONFIRM_SOURCE_BY_SURFACE: Readonly<
  Record<AppSurface, Exclude<ConfirmRequestSource, 'dev_auto'> | null>
> = {
  console: 'client_app',
  tablet: 'tablet',
  module: null,
}
